import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Administration } from '@/pages/administration';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { documentsSearchSchema } from '@/routes/protected/_layout/documents/_layout';

export const Route = createFileRoute(
  '/protected/_layout/administration/_layout'
)({
  validateSearch: documentsSearchSchema,
  component: AdministrationLayout,
});

function AdministrationLayout() {
  const { canAccessAdministration, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessAdministration} isLoading={isLoading}>
      <Administration />
      <Outlet />
    </RoleGuard>
  );
}
